import React from 'react';
import cn from 'classnames';
import { CdnIcon } from '@shared/ui';
import { BaseButton, ModalX } from '../../../../../BaseComponents';
import { useTheme } from '../../../../../theme';
const ExchangeRefundModal = ({ className, status, title, description, cancel, success, close }) => {
    const { ExchangeRefundModal: theme } = useTheme('Entities').Order;
    const icon = status === 'success' ? 'Info/Item Icluded' : 'Info/Warning';
    return (React.createElement(ModalX, { isOpen: true, onClose: close, classes: { root: className, content: theme.content }, title: React.createElement("div", { className: theme.header },
            React.createElement("div", { className: cn(theme.icon, theme[status]) },
                React.createElement(CdnIcon, { icon: icon })),
            !!title && React.createElement("span", { className: theme.title }, title)), footer: React.createElement("div", { className: theme.footer },
            cancel && (React.createElement(BaseButton, { className: theme.cancel, variant: "secondary", onClick: cancel.onClick, fullWidth: true }, cancel.text)),
            success && (React.createElement(BaseButton, { variant: "action", onClick: success.onClick, fullWidth: true }, success.text))) }, !!description && React.createElement("span", { className: theme.description }, description)));
};
export default ExchangeRefundModal;
